import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { setAppliedFilters } from '../../../../../../reducers/Filters/actions';
import { ZorbaButton, ZorbaInput } from '../../../../../../components/forms';
import { BUTTON_VARIANT_DARK } from '../../../../../../components/forms/ZorbaButton/constants';

export const AssetsNumberBuilder = ({ onApplyFilter }) => {
  const dispatch = useDispatch();
  const { appliedFilters } = useSelector(
    ({ FiltersReducer }) => FiltersReducer,
  );
  const defaultValue = appliedFilters.numberOfUnits;
  const [selectedMinAssetsNumber, setSelectedMinAssetsNumber] = useState(
    defaultValue?.min,
  );
  const [selectedMaxAssetsNumber, setSelectedMaxAssetsNumber] = useState(
    defaultValue?.max,
  );

  const isApplyButtonDisabled =
    !selectedMinAssetsNumber && !selectedMaxAssetsNumber;

  const handleApply = () => {
    dispatch(
      setAppliedFilters('numberOfUnits', {
        min: selectedMinAssetsNumber,
        max: selectedMaxAssetsNumber,
      }),
    );
    onApplyFilter();
  };

  return (
    <div className="builder-container">
      <h3>Number of units</h3>
      <div className="options-container">
        <ZorbaInput
          label="Min number of units"
          fullWidth
          minValue={0}
          type="number"
          value={selectedMinAssetsNumber}
          onChange={(e) => setSelectedMinAssetsNumber(e)}
          symbol=""
        />
        <ZorbaInput
          label="Max number of units"
          fullWidth
          minValue={0}
          type="number"
          value={selectedMaxAssetsNumber}
          onChange={(e) => setSelectedMaxAssetsNumber(e)}
          symbol=""
        />
      </div>
      <ZorbaButton
        variant={BUTTON_VARIANT_DARK}
        disabled={isApplyButtonDisabled}
        onClick={handleApply}
        fullWidth={false}
      >
        Apply
      </ZorbaButton>
    </div>
  );
};
